import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import type { RequestGetStudentChallenges } from "@/entities/student-challenge/domain/repository";
import type { GetStudentChallengesResponseDto } from "@/entities/student-challenge/domain/dtos";
import { StudentChallengeRepository } from "@/entities/student-challenge/domain/repository";

const DEFAULT_STUDENT_CHALLENGES_ORDERS = encodeURIComponent(JSON.stringify([{ name: 0 }]));

@singleton()
export default class StudentChallengesRepositoryImpl implements StudentChallengeRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    getStudentChallenges = async (request: RequestGetStudentChallenges) => {
        let url = `/v2/academies/${request.academyId}/student-challenges?`;

        url += `challengeTemplateId=${request.challengeTemplateId}&`;
        url += `size=${request.size ?? 20}&`;
        url += `orders=${DEFAULT_STUDENT_CHALLENGES_ORDERS}&`;

        if (request.keyword) {
            url += `keyword=${request.keyword}&`;
        }

        if (request.studentGroupId) {
            url += `studentGroupId=${request.studentGroupId}&`;
        }

        if (request.withUngroupedStudents) {
            url += `withUngroupedStudents=true&`;
        }

        if (request.nextToken) {
            url += `nextToken=${encodeURIComponent(request.nextToken)}`;
        }

        const response = await this.server.get<GetStudentChallengesResponseDto>(url);

        return response;
    };
};
